/* Favoritos Gogana — localStorage, sin apps externas.
   La clave llevaba el prefijo `fds_` (fundasdesofa): espacio de nombres de OTRO
   cliente, heredado al copiar el tema. Renombrada a `gogana_wishlist` según el
   canon de hive, que pide prefijo por proyecto. */
(function () {
  var KEY = 'gogana_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      /* La etiqueta acompaña al estado: un lector de pantalla decía «Guardar en
         favoritos» sobre un producto YA guardado. Los textos vienen traducidos
         desde el Liquid; si el botón no los trae, se queda como estaba. */
      var etiqueta = btn.getAttribute(active ? 'data-label-quitar' : 'data-label-guardar');
      if (etiqueta) btn.setAttribute('aria-label', etiqueta);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
    paint();
  });

  document.addEventListener('wishlist:change', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();

  /* Página de favoritos: pinta las mismas tarjetas que colecciones (product-card vía ?view=card) */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (grid) {
    var empty = document.querySelector('[data-wishlist-empty]');
    var favs = read();
    if (!favs.length) {
      if (empty) empty.style.display = '';
      return;
    }
    Promise.all(favs.map(function (handle) {
      return fetch('/products/' + handle + '?view=card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    })).then(function (cards) {
      cards.forEach(function (html) { if (html) grid.insertAdjacentHTML('beforeend', html); });
      paint();
      document.addEventListener('wishlist:change', function () {
        var l = read();
        grid.querySelectorAll('.product-card').forEach(function (card) {
          var btn = card.querySelector('[data-wishlist-toggle]');
          var h = btn && btn.getAttribute('data-handle');
          if (h && l.indexOf(h) === -1) card.remove();
        });
        if (!read().length && empty) empty.style.display = '';
      });
    });
  }
})();
